import { Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import HizmetPage from 'src/components/DefectPage';
import { safeParseInt } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { getDefectRequest, getLabourRequest, getMaterialRequest } from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import { addMaterials, resetMaterials } from '../../store/actions/materialActions';


const useStyles = makeStyles(() => ({
  root: {},
  contentH: {
    minHeight: 430,
  },
}));

function Hizmet({  FisNo, readonly, tasks, resetDefects, resetLabours, resetMaterials, defectReducer, labourReducer, materialReducer,
  getDefectRequest, getLabourRequest, getMaterialRequest, addDefects, addLabours, addMaterials }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");

  // useRef ile önceki reducer değerlerini takip et
  const prevReducersRef = useRef({ defectReducer: null, labourReducer: null, materialReducer: null });

  const loading = defectReducer?.loading || materialReducer?.loading || labourReducer?.loading;

  // 1. DÜZENLEME: HizmetData'yı güvenli al ve her zaman dizi olduğundan emin ol
  let HizmetData = readonly
    ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : [])
    : (loadBaslandiJob() || []);

  if (!readonly && (!HizmetData || HizmetData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      HizmetData = loadBaslandiJob() || [];
    }
  }

  let garantiTipi = 0;
  let garantiTipiText = '';
  let kulModelKodu = '';
  let Uyil = '';
  let Udonem = '';
  let SeriNo = '';
  let Barcode = '';
  let Model = '';

  if (HizmetData?.length > 0) {
    garantiTipi = HizmetData[0]?.GARANTI_TIPI || 1;
    garantiTipiText = HizmetData[0]?.GARANTI_TIPI_TEXT || "";
    kulModelKodu = HizmetData[0]?.KUL_MODEL_KODU || '';
    Uyil = HizmetData[0]?.UYIL || '';
    Udonem = HizmetData[0]?.UDONEM || '';
    SeriNo = HizmetData[0]?.SERINO || '';
    Barcode = HizmetData[0]?.BARKOD || '';
    Model = HizmetData[0]?.MODEL || '';

  }

  const handleClose = () => {
    setOpen(false);
  };

  // NOT: İlk API call'ları WorkOrder/index.js tarafından yapılıyor
  // Burada tekrar çağırmaya gerek yok - duplicate request'leri önlemek için kaldırıldı
  // checkHizmet, checkMalzeme, checkIscilik kontrolü de artık gerekli değil
  // çünkü WorkOrder/index.js zaten mount'ta bu verileri yüklüyor

  const [hasLoadedMerkez, setHasLoadedMerkez] = useState(false);

  useEffect(() => {
    if (readonly || hasLoadedMerkez) {
      return;
    }
    const merkez = Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : [];
    const local = loadBaslandiJob() || [];
    
    if (!merkez[0] || !local[0]) {
      return;
    }
    
    if (merkez[0]?.KUL_MODEL_KODU === local[0]?.KUL_MODEL_KODU) {
      if ((merkez[0]?.HIZMETLER?.length || 0) > 0 && (local[0]?.HIZMETLER?.length || 0) === 0) {

        setUyari("Fişe verilmiş hizmetler merkezden tekrardan alınıyor!..");
        setOpen(true);
        resetDefects();
        resetMaterials();
        resetLabours();
        getDefectRequest(merkez[0]?.KUL_MODEL_KODU, 1);
        getMaterialRequest(merkez[0]?.KUL_MODEL_KODU, 1, 1, merkez[0]?.UYIL || 0, merkez[0]?.UDONEM || 0, merkez[0]?.SERINO || '0');
        getLabourRequest(merkez[0]?.KUL_MODEL_KODU, 1, 1);
        let curr = merkez[0];
        if (curr.HIZMETLER) {
          const selectedDefects = [];
          let laboursHizmet = {};
          let materialsHizmet = {};
          curr.HIZMETLER.forEach(function (h, index) {
            selectedDefects.push(h.HIZMET_KODU);
            laboursHizmet = { ...laboursHizmet, [h.HIZMET_KODU]: [] };
            materialsHizmet = { ...materialsHizmet, [h.HIZMET_KODU]: [] };
          });
          addDefects(selectedDefects);
          if (curr.ISCILIKLER) {
            curr.ISCILIKLER.forEach(function (i, index) {
              laboursHizmet[i.HIZMET_KODU].push(i.KUL_ISCILIK_KODU.toString());
            });
            addLabours(laboursHizmet);
          }
          if (curr.MALZEMELER) {
            curr.MALZEMELER.forEach(function (i, index) {
              materialsHizmet[i.HIZMET_KODU].push(i.MALZEME_STOK_NO.toString());
              materialsHizmet = { ...materialsHizmet, [i.MALZEME_STOK_NO]: safeParseInt(i.ADET) }
            });
            addMaterials(materialsHizmet);
          }
        }
        setHasLoadedMerkez(true);
      }
    }
    // eslint-disable-next-line
  }, [readonly, FisNo, hasLoadedMerkez]);

  const localStorageKaydet = useCallback(() => {

    if (readonly || !defectReducer?.Data || defectReducer.Data.length === 0) return;


    let jobDataList = loadBaslandiJob();
    if (!jobDataList || jobDataList.length === 0) return;
    let job = jobDataList?.[0];



    let hizmetlerH = [];
    let isciliklerH = [];
    let malzemelerH = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;



    for (let h = 0; h < defectReducer?.selected?.length; h++) {
      const hizmet = defectReducer?.selected[h];
      const hizmetRedux = defectReducer?.defectsTable[hizmet];
      
      // Duplicate kontrolü - aynı hizmet daha önce eklenmişse atla
      if (hizmetlerH.some(item => item.HIZMET_KODU === hizmet)) {
        continue;
      }
      
      hizmetlerH.push({
        HIZMET_KODU: hizmet,
        KUL_HIZMET_KODU: hizmetRedux?.UserCode,
        ACIKLAMA: hizmetRedux?.DefectDesc,
        TIP: hizmetRedux?.DefectType,
        TIP_KODU: hizmetRedux?.DefectTypeCode,
      });
      const labourArray = labourReducer[hizmet];
      if (Array.isArray(labourArray) && labourArray?.length > 0) {
        for (let i = 0; i < labourArray?.length; i++) {
          const iscilik = labourReducer?.Data?.filter(d => d.LabourCode === labourArray[i])[0];
          if (iscilik) {
            isciliklerH.push({
              ISCILIK_KODU: iscilik?.LabourId,
              HIZMET_KODU: hizmet,
              KUL_ISCILIK_KODU: iscilik?.LabourCode,
              ACIKLAMA: iscilik?.LabourDesc,
              FIYAT: parseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0),
              FIYAT_LISTESI_ID: parseInt(job?.GARANTI_TIPI) === 1 ? iscilik?.PriceListIdWithoutWarranty : iscilik?.PriceListId,
              FIYAT_KODU: safeParseInt(iscilik?.PriceId)
            });
            iscilik_toplam += parseInt(job?.GARANTI_TIPI) === 1 ? (iscilik?.PriceWithoutWarranty || 0) : (iscilik?.Price || 0);
          }
        }
      }

      const materialArray = materialReducer[hizmet];
      if (Array.isArray(materialArray) && materialArray?.length > 0) {
        for (let m = 0; m < materialArray?.length; m++) {
          const malzeme = materialReducer?.Data?.filter(d => d.MaterialCode === materialArray[m])[0];
          if (!malzeme) continue; // <<< BU SATIR HATAYI BİTİRİR
          if (malzeme) {
            malzemelerH.push({
              MALZEME_KODU: malzeme?.MaterialId,
              HIZMET_KODU: hizmet,
              MALZEME_STOK_NO: malzeme?.MaterialCode,
              ADET: materialReducer[malzeme?.MaterialCode],
              ACIKLAMA: malzeme?.MaterialDesc,
              FIYAT: malzeme?.PriceWithWat,
              FIYAT_LISTESI_ID: malzeme?.PriceListId,
              FIYAT_KODU: safeParseInt(malzeme.PriceId)
            })
            malzeme_toplam += materialReducer[malzeme?.MaterialCode] * malzeme?.PriceWithWat;
          }
        }
      }


    }
    job = {
      ...job,
      HIZMETLER: hizmetlerH,
      ISCILIKLER: isciliklerH,
      MALZEMELER: malzemelerH,
      ISCILIK_TOPLAM: iscilik_toplam,
      MALZEME_TOPLAM: malzeme_toplam,
    }
    saveBaslandiJob(job);
  }, [readonly, defectReducer, labourReducer, materialReducer]);

  // LocalStorage kaydetme: Sadece seçimler gerçekten değiştiğinde
  useEffect(() => {
    if (readonly || loading) {
      return;
    }

    const prev = prevReducersRef.current;
    const selectedChanged = prev.defectReducer?.selected !== defectReducer?.selected;
    const labourChanged = prev.labourReducer !== labourReducer;
    const materialChanged = prev.materialReducer !== materialReducer;

    if (selectedChanged || labourChanged || materialChanged) {
      localStorageKaydet();
      prevReducersRef.current = { defectReducer, labourReducer, materialReducer };
    }
    // eslint-disable-next-line
  }, [defectReducer?.selected, labourReducer, materialReducer, loading, readonly]);


  if (HizmetData[0]?.KUL_MODEL_KODU === undefined || HizmetData[0]?.KUL_MODEL_KODU === '' || HizmetData[0]?.KUL_MODEL_KODU === null) {
    return <Card>
      <CardHeader title="Ürün Kontrolü" />
      <Divider />
      <CardContent className={classes.contentH}>
        Ürün seçimi yapılmadığı için hizmetler listelenemiyor!... Lütfen önce ürün seçimi yapınız!...
      </CardContent>
    </Card>;
  }





  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {defectReducer?.error?.length > 0 && <Typography>Hizmet Hata: {defectReducer?.error}</Typography>}
      {labourReducer?.error?.length > 0 && <Typography>İşçilik Hata: {labourReducer?.error}</Typography>}
      {materialReducer?.error?.length > 0 && <Typography>Hizmet Hata: {materialReducer?.error}</Typography>}
      {
        loading ?
          <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          />
          :
          (defectReducer?.Data?.length === 0 && !window?.navigator?.onLine ? (
            <Card>
              <CardHeader title="Offline Data Kontrolü" />
              <Divider />
              <CardContent className={classes.contentH}>
                Offline Olduğunuz sırada merkezden datalar alınamadığı için sayfa görüntülenemiyor. Online olduktan sonra tekrar deneyiniz.
              </CardContent>
            </Card>
          ) :
            <HizmetPage
              FisNo={FisNo}
              garantiTipi={garantiTipi || 1}
              garantiTipiText={garantiTipiText || ""}
              readonly={readonly}
              kulModelKodu={kulModelKodu || ""}
              Uyil={Uyil || ""}
              Udonem={Udonem || ""}
              SeriNo={SeriNo || ""}
              Barcode={Barcode || ""}
              Model={Model || ""}
            />
          )
      }
    </div>
  );
}

Hizmet.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
    // resetDefects: state.resetDefects,
    // resetLabours: state.resetLabours,
    // resetMaterials: state.resetMaterials,
  }), {
  resetDefects, resetLabours, resetMaterials, getDefectRequest, getLabourRequest, getMaterialRequest, addDefects, addLabours, addMaterials
}
)(Hizmet);
